import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const DynamicComponent = dynamic(
	() => import('../../components/Sudoku/app.js').then((mod) => mod.Sudoku),
	{ ssr: false }
);

const Games = () => {
	return (
		<>
			<DynamicComponent />
		</>
	);
};

export const getStaticProps = async ({ params, locale }) => {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common'])),
		},
		revalidate: 1,
	};
};

export default Games;
